<template>
  <!-- -------------Most Wanted Section------------------ -->
  <div class="container-fluid products-list pt-5 pb-5">
    <h4>{{ product.category }}: {{ product.name }}</h4>
    <div class="underline-green"></div>
    <br />
    <br />
    <SingleProduct :product="product" />
    <RelatedProducts />
  </div>
</template>

<script>
import RelatedProducts from "../components/RelatedProducts";
import SingleProduct from "../components/SingleProduct";
export default {
  name: "Product",
  components: {
    RelatedProducts,
    SingleProduct
  },
  props: ["id"],
  computed: {
    product() {
      const id = this.id;
      return this.$store.getters.productById(id);
    }
  },
  mounted() {
    document.title = "MB Clothing | " + this.id;
    this.$store.state.showSearch = false;
  }
};
</script>

<style></style>
